import { render } from "./homeResourceCentre.vue?vue&type=template&id=151194a8&scoped=true"
import script from "./homeResourceCentre.vue?vue&type=script&lang=js"
export * from "./homeResourceCentre.vue?vue&type=script&lang=js"

import "./homeResourceCentre.vue?vue&type=style&index=0&id=151194a8&lang=scss&scoped=true"

import exportComponent from "E:\\edu-ui\\JzEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-151194a8"]])

export default __exports__